module.exports = __webpack_public_path__ + "img/soul-land3d.4ae6947.png";